import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { BrandLogo } from '../../shared/BrandLogo'
import { adminApi } from '../api'
import { safeAdminError } from '../safe-ui'

export function AdminForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [info, setInfo] = useState('')
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError('')
    setInfo('')
    try {
      const res = await adminApi.forgotPassword(email.trim())
      setInfo(res.message || 'If an admin account exists for that email, a reset link has been sent.')
    } catch (err) {
      setError(safeAdminError(err, 'Unable to send reset link'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="ap-auth">
      <form className="ap-auth__card" onSubmit={(e) => void onSubmit(e)}>
        <BrandLogo className="ap-auth__logo" tone="light" variant="mark" />
        <p className="cp-eyebrow">Master Admin</p>
        <h1>Forgot password</h1>
        <p className="cp-muted">We will email a secure reset link if an admin account exists.</p>
        {error ? <p className="cp-error">{error}</p> : null}
        {info ? <p className="cp-success">{info}</p> : null}
        <label className="cp-field">
          Email
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <button type="submit" className="pp-btn pp-btn--primary" disabled={busy}>
          {busy ? 'Sending…' : 'Send reset link'}
        </button>
        <p className="cp-muted" style={{ marginTop: '0.85rem' }}>
          <Link to="/admin/login">Back to sign in</Link>
        </p>
      </form>
    </div>
  )
}
